(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin_city_smartb_s2_s2_automate_dsl.js', './kotlin_kotlin.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin_city_smartb_s2_s2_automate_dsl.js'), require('./kotlin_kotlin.js'));
  else {
    if (typeof kotlin_city_smartb_s2_s2_automate_dsl === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_measure_unit_domain'. Its dependency 'kotlin_city_smartb_s2_s2_automate_dsl' was not found. Please, check whether 'kotlin_city_smartb_s2_s2_automate_dsl' is loaded prior to 'kotlin_org_axessimpact_measure_unit_domain'.");
    }
    if (typeof kotlin_kotlin === 'undefined') {
      throw new Error("Error loading module 'kotlin_org_axessimpact_measure_unit_domain'. Its dependency 'kotlin_kotlin' was not found. Please, check whether 'kotlin_kotlin' is loaded prior to 'kotlin_org_axessimpact_measure_unit_domain'.");
    }
    root.kotlin_org_axessimpact_measure_unit_domain = factory(typeof kotlin_org_axessimpact_measure_unit_domain === 'undefined' ? {} : kotlin_org_axessimpact_measure_unit_domain, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin);
  }
}(this, function (_, kotlin_city_smartb_s2_s2_automate_dsl, kotlin_kotlin) {
  //region block: imports
  var imul = Math.imul;
  var S2Role = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Role;
  var S2State = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2State;
  var S2InitCommand = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitCommand;
  var S2Event = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Event;
  var S2InitTransitionBuilder = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2InitTransitionBuilder;
  var getKClass = kotlin_kotlin.$crossModule$.getKClass;
  var S2Transition = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.S2Transition;
  var Unit_getInstance = kotlin_kotlin.$crossModule$.Unit_getInstance;
  var s2 = kotlin_city_smartb_s2_s2_automate_dsl.$crossModule$.s2;
  var getStringHashCode = kotlin_kotlin.$crossModule$.getStringHashCode;
  var THROW_CCE = kotlin_kotlin.$crossModule$.THROW_CCE;
  //endregion
  'use strict';
  //region block: pre-declaration
  Created.prototype = Object.create(MeasureUnitState.prototype);
  Created.prototype.constructor = Created;
  //endregion
  function _get_S2MeasureUnit__3803518190() {
    init_properties_S2MeasureUnit_kt_1396605745();
    return S2MeasureUnit;
  }
  var S2MeasureUnit;
  function s2MeasureUnit() {
    init_properties_S2MeasureUnit_kt_1396605745();
    return _get_S2MeasureUnit__3803518190();
  }
  function Admin() {
  }
  Admin.$metadata$ = {
    simpleName: 'AdminRole',
    kind: 'class',
    interfaces: [S2Role]
  };
  function Created() {
    Created_instance = this;
    MeasureUnitState.call(this, 0);
  }
  Created.$metadata$ = {
    simpleName: 'Created',
    kind: 'object',
    interfaces: []
  };
  var Created_instance;
  function Created_getInstance() {
    if (Created_instance == null)
      new Created();
    return Created_instance;
  }
  function MeasureUnitState(position) {
    this.position_1 = position;
  }
  MeasureUnitState.prototype._set_position__3963083214_ves4de_k$ = function (_set____804775014) {
    this.position_1 = _set____804775014;
  };
  MeasureUnitState.prototype._get_position__3188952002_iahqv2_k$ = function () {
    return this.position_1;
  };
  MeasureUnitState.prototype.equals = function (other) {
    var tmp;
    if (other instanceof MeasureUnitState) {
      tmp = other.position === this.position;
    } else {
      {
        tmp = false;
      }
    }
    return tmp;
  };
  MeasureUnitState.prototype.hashCode = function () {
    return this.position;
  };
  MeasureUnitState.$metadata$ = {
    simpleName: 'MeasureUnitState',
    kind: 'class',
    interfaces: [S2State]
  };
  Object.defineProperty(MeasureUnitState.prototype, 'position', {
    configurable: true,
    get: function () {
      return this._get_position__3188952002_iahqv2_k$();
    },
    set: function (value) {
      this._set_position__3963083214_ves4de_k$(value);
    }
  });
  function MeasureUnitInitCommand() {
  }
  MeasureUnitInitCommand.$metadata$ = {
    simpleName: 'MeasureUnitInitCommand',
    kind: 'interface',
    interfaces: [S2InitCommand]
  };
  function MeasureUnitEvent() {
  }
  MeasureUnitEvent.$metadata$ = {
    simpleName: 'MeasureUnitEvent',
    kind: 'interface',
    interfaces: [S2Event]
  };
  function S2MeasureUnit$lambda() {
    return function ($this$s2) {
      $this$s2._set_name__589551916_2ji656_k$('MeasureUnitS2');
      var builder_1 = new S2InitTransitionBuilder();
      {
        builder_1._set_to__3473241468_c5v2kc_k$(Created_getInstance());
        builder_1._set_role__593662113_xqqqxo_k$(new Admin());
      }
      var tmp$ret$0;
      $l$block: {
        var tmp0_to_3 = builder_1._get_to__1413131888_ndcbjk_k$();
        var tmp1_role_4 = builder_1._get_role__808279189_dd887p_k$();
        var tmp0_let_0_2 = new S2Transition(null, tmp0_to_3, tmp1_role_4, getKClass(MeasureUnitCreateCommand));
        var tmp1_let_5 = $this$s2._get_transactions__188093078_33zhjq_k$();
        {
        }
        tmp$ret$0 = tmp1_let_5.add_1j60pz_k$(tmp0_let_0_2);
        break $l$block;
      }
      Unit_getInstance();
      return Unit_getInstance();
    };
  }
  var properties_initialized_S2MeasureUnit_kt_1704458893;
  function init_properties_S2MeasureUnit_kt_1396605745() {
    if (!properties_initialized_S2MeasureUnit_kt_1704458893) {
      properties_initialized_S2MeasureUnit_kt_1704458893 = true;
      S2MeasureUnit = s2(S2MeasureUnit$lambda());
    }
  }
  function MeasureUnitCreateCommandDTO() {
  }
  MeasureUnitCreateCommandDTO.$metadata$ = {
    simpleName: 'MeasureUnitCreateCommandDTO',
    kind: 'interface',
    interfaces: [MeasureUnitInitCommand]
  };
  function MeasureUnitCreatedEventDTO() {
  }
  MeasureUnitCreatedEventDTO.$metadata$ = {
    simpleName: 'MeasureUnitCreatedEventDTO',
    kind: 'interface',
    interfaces: [MeasureUnitEvent]
  };
  function MeasureUnitCreateCommand(name, notation, image) {
    this.name_1 = name;
    this.notation_1 = notation;
    this.image_1 = image;
  }
  MeasureUnitCreateCommand.prototype._get_name__804168992_das4rk_k$ = function () {
    return this.name_1;
  };
  MeasureUnitCreateCommand.prototype._get_notation__3167364105_incg6v_k$ = function () {
    return this.notation_1;
  };
  MeasureUnitCreateCommand.prototype._get_image__3321984470_g3aecq_k$ = function () {
    return this.image_1;
  };
  MeasureUnitCreateCommand.prototype.toString = function () {
    return 'MeasureUnitCreateCommand(name=' + this.name_1 + ', notation=' + this.notation_1 + ', image=' + this.image_1 + ')';
  };
  MeasureUnitCreateCommand.prototype.hashCode = function () {
    var result = getStringHashCode(this.name_1);
    result = imul(result, 31) + getStringHashCode(this.notation_1) | 0;
    result = imul(result, 31) + (this.image_1 == null ? 0 : getStringHashCode(this.image_1)) | 0;
    return result;
  };
  MeasureUnitCreateCommand.prototype.equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MeasureUnitCreateCommand))
      return false;
    else {
    }
    var tmp0_other_with_cast = other instanceof MeasureUnitCreateCommand ? other : THROW_CCE();
    if (!(this.name_1 === tmp0_other_with_cast.name_1))
      return false;
    if (!(this.notation_1 === tmp0_other_with_cast.notation_1))
      return false;
    if (!(this.image_1 == tmp0_other_with_cast.image_1))
      return false;
    return true;
  };
  MeasureUnitCreateCommand.$metadata$ = {
    simpleName: 'MeasureUnitCreateCommand',
    kind: 'class',
    interfaces: [MeasureUnitCreateCommandDTO]
  };
  Object.defineProperty(MeasureUnitCreateCommand.prototype, 'name', {
    configurable: true,
    get: function () {
      return this._get_name__804168992_das4rk_k$();
    }
  });
  Object.defineProperty(MeasureUnitCreateCommand.prototype, 'notation', {
    configurable: true,
    get: function () {
      return this._get_notation__3167364105_incg6v_k$();
    }
  });
  Object.defineProperty(MeasureUnitCreateCommand.prototype, 'image', {
    configurable: true,
    get: function () {
      return this._get_image__3321984470_g3aecq_k$();
    }
  });
  function MeasureUnitDTO() {
  }
  MeasureUnitDTO.$metadata$ = {
    simpleName: 'MeasureUnitDTO',
    kind: 'interface',
    interfaces: []
  };
  //region block: exports
  function $jsExportAll$(_) {
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$measure = $org$axess$s2.measure || ($org$axess$s2.measure = {});
    var $org$axess$s2$measure$unit = $org$axess$s2$measure.unit || ($org$axess$s2$measure.unit = {});
    var $org$axess$s2$measure$unit$domain = $org$axess$s2$measure$unit.domain || ($org$axess$s2$measure$unit.domain = {});
    $org$axess$s2$measure$unit$domain.s2MeasureUnit = s2MeasureUnit;
    $org$axess$s2$measure$unit$domain.Admin = Admin;
    $org$axess$s2$measure$unit$domain.MeasureUnitState = MeasureUnitState;
    Object.defineProperty($org$axess$s2$measure$unit$domain.MeasureUnitState, 'Created', {
      configurable: true,
      get: Created_getInstance
    });
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$measure = $org$axess$s2.measure || ($org$axess$s2.measure = {});
    var $org$axess$s2$measure$unit = $org$axess$s2$measure.unit || ($org$axess$s2$measure.unit = {});
    var $org$axess$s2$measure$unit$domain = $org$axess$s2$measure$unit.domain || ($org$axess$s2$measure$unit.domain = {});
    var $org$axess$s2$measure$unit$domain$features = $org$axess$s2$measure$unit$domain.features || ($org$axess$s2$measure$unit$domain.features = {});
    var $org$axess$s2$measure$unit$domain$features$command = $org$axess$s2$measure$unit$domain$features.command || ($org$axess$s2$measure$unit$domain$features.command = {});
    var $org = _.org || (_.org = {});
    var $org$axess = $org.axess || ($org.axess = {});
    var $org$axess$s2 = $org$axess.s2 || ($org$axess.s2 = {});
    var $org$axess$s2$measure = $org$axess$s2.measure || ($org$axess$s2.measure = {});
    var $org$axess$s2$measure$unit = $org$axess$s2$measure.unit || ($org$axess$s2$measure.unit = {});
    var $org$axess$s2$measure$unit$domain = $org$axess$s2$measure$unit.domain || ($org$axess$s2$measure$unit.domain = {});
    var $org$axess$s2$measure$unit$domain$model = $org$axess$s2$measure$unit$domain.model || ($org$axess$s2$measure$unit$domain.model = {});
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlin_org_axessimpact_measure_unit_domain.js.map